<template>
  <div>
    <iframe :src="Url" width="100%" height="800px" style="border:0"/>
  </div>
</template>

<script>
import { ACTIONS, CORE_PREFIX } from '../store/constants';
import { authService } from '../msal';

export default {
  mounted() {
    this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
  },
  computed: {
    Url() {
      let segmentation = $cookies.get('segmentation');
      let url = "https://nice-sky-0fe8f8903.4.azurestaticapps.net?UserId=" + authService.getUser().id;
      if (segmentation === "YOYOSweden")
        url = "https://zealous-plant-0ee1b1703.5.azurestaticapps.net?UserId=" + authService.getUser().id;
      return url;
    },
  },
};
</script>